module.exports = __webpack_public_path__ + "img/ski_sub_title2m.7deb52be.jpg";